export enum RoleStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}

export enum RoleNameEnum {
  RESIDENT = "RESIDENT",
  CLERK = "CLERK",
  FACILITY_ADMIN = "FACILITY_ADMIN",
  ADMISSIONS_DIRECTOR = "ADMISSIONS_DIRECTOR",
  REGIONAL_ADMIN = "REGIONAL_ADMIN",
  ORGANIZATION_IT_ADMIN = "ORGANIZATION_IT_ADMIN",
  ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
  RESIDE_ADMIN = "RESIDE_ADMIN",
}
export enum RoleScopeEnum {
  RESIDENT = "RESIDENT",
  FACILITY = "FACILITY",
  ORGANIZATION = "ORGANIZATION",
  RESIDE = "RESIDE",
}

export enum PermissionTypeEnum {
  ADMISSION = "ADMISSION",
  FACILITY = "FACILITY",
  ORGANIZATION = "ORGANIZATION",
  USER = "USER",
}

export interface RoleDto {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly type: PermissionTypeEnum;
}

export enum DirectionEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export interface PageableDto {
  readonly direction?: DirectionEnum;
  readonly page?: number;
  readonly properties?: ReadonlyArray<string>;
  readonly size?: number;
}

export interface ErrorResponseDto {
  readonly code?: string;
  readonly message?: string;
  readonly path?: string;
  readonly status?: number;
  readonly timestamp?: string;
  readonly trace?: string;
  readonly type?: string;
}
